import React, { FC, useCallback } from 'react';
import { ReactComponent as SectionImage1 } from 'assets/svgs/resource-management/section_1.svg';
import { ReactComponent as SectionImage2 } from 'assets/svgs/resource-management/section_2.svg';
import { ReactComponent as SectionImage3 } from 'assets/svgs/resource-management/section_3.svg';
import { Button } from 'components/atoms/button';
import { FeatureDiscovery } from 'components/molecules/feature-discovery';
import { Page } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';
import { useUser } from 'hooks/use-user';
import { useUpdateUserMetaMutation } from 'queries';

const {
  Header: { Title: PageTitle },
} = Page;
const {
  Section: { Content, Media },
  BannerSection: { Content: BannerContent, Media: BannerMedia },
} = FeatureDiscovery;

export const ResourceManagementLandingPage: FC = () => {
  const {
    userMeta: { metaData },
  } = useUser();
  const { mutate, isLoading } = useUpdateUserMetaMutation();
  const onGetStarted = useCallback(
    () =>
      mutate({
        metaData: { ...metaData, startedWithResourceManagement: true },
      }),
    [mutate, metaData],
  );

  return (
    <Page>
      <Page.Header
        title={
          <PageTitle>
            {useTranslation('menu.label.resource_management')}
          </PageTitle>
        }
      />
      <Page.Content>
        <FeatureDiscovery>
          <FeatureDiscovery.BannerSection>
            <BannerMedia>
              <SectionImage1 />
            </BannerMedia>
            <BannerContent>
              <BannerContent.Title>
                {useTranslation(
                  'resource_management.feature_discovery.section_1.title',
                )}
              </BannerContent.Title>
              <BannerContent.Description>
                {useTranslation(
                  'resource_management.feature_discovery.section_1.description',
                )}
              </BannerContent.Description>
              <BannerContent.Actions>
                <Button
                  onClick={onGetStarted}
                  loading={isLoading}
                  type="primary"
                  data-cy="rm.get_started"
                >
                  {useTranslation('get_started')}
                </Button>
              </BannerContent.Actions>
            </BannerContent>
          </FeatureDiscovery.BannerSection>
          <FeatureDiscovery.Section>
            <Media>
              <SectionImage2 />
            </Media>
            <Content>
              <Content.Title>
                {useTranslation(
                  'resource_management.feature_discovery.section_2.title',
                )}
              </Content.Title>
              <Content.Description>
                {useTranslation(
                  'resource_management.feature_discovery.section_2.description',
                )}
              </Content.Description>
              <Content.Actions>
                <Button
                  onClick={onGetStarted}
                  loading={isLoading}
                  type="primary"
                >
                  {useTranslation('get_started')}
                </Button>
              </Content.Actions>
            </Content>
          </FeatureDiscovery.Section>
          <FeatureDiscovery.Section>
            <Content>
              <Content.Title>
                {useTranslation(
                  'resource_management.feature_discovery.section_3.title',
                )}
              </Content.Title>
              <Content.Description>
                {useTranslation(
                  'resource_management.feature_discovery.section_3.description',
                )}
              </Content.Description>
              <Content.Actions>
                <Button
                  onClick={onGetStarted}
                  loading={isLoading}
                  type="primary"
                >
                  {useTranslation('get_started')}
                </Button>
              </Content.Actions>
            </Content>
            <Media>
              <SectionImage3 />
            </Media>
          </FeatureDiscovery.Section>
        </FeatureDiscovery>
      </Page.Content>
    </Page>
  );
};
